<template>
  <div>
    
    <div class="title_text">

      <div>
        <Icon type="ios-bookmark" size="18" color="#0466dd" />

        <span class="title_text2">项目结算</span>
      </div>

      <div class="query_box">
        <DatePicker type="month" @on-change="date_change" v-model="current_month" size="small" placement="bottom-end"
          placeholder="选择日期" style="width: 100px" />
      </div>
    </div>

    <div class="data_div">
      <div class="card_main">
        <div class="card_main01">
          <Spin fix v-if="loading"></Spin>

          <div class="count_card3" @click="click_cash_pledge">
            <div class="count_up">
              <CountUp :end="cash_pledge_balances" :decimals="2" duration="3" ref="count" v-font="18" />
            </div>

            <div class="count_title2">项目(组)保证金</div>
          </div>

          <div class="count_card">
            <div class="count_up">
              <CountUp :end="start_invoice_money" :decimals="2" duration="3" ref="count" v-font="18" />
            </div>

            <div class="count_title">本月期初应收</div>
          </div>

          <div class="count_card">
            <div class="count_up">
              <CountUp :end="current_invioce_money" :decimals="2" duration="3" ref="count" v-font="18" />
            </div>

            <div class="count_title">本月开票</div>
          </div>

          <div class="count_card">
            <div class="count_up">
              <CountUp :end="current_returned_money" :decimals="2" duration="3" ref="count" v-font="18" />
            </div>

            <div class="count_title">本月回款(含预收)</div>
          </div>

          <div class="count_card">
            <div class="count_up">
              <CountUp :end="weihuikuan_money" :decimals="2" :duration="3" ref="count" v-font="18" />
            </div>

            <div class="count_title">本月未回款</div>
          </div>
        </div>

        <div class="count_card3" @click="click_kaipiao">
          <div>
            <span class="iconfont iconjiesuan icon_select"></span>

            <!-- <CountUp :end="interview_data.yaoyue.length" :duration="4" ref="count" v-font="22" /> -->
          </div>

          <div class="count_title2">发起结算(开票)</div>
        </div>

        <div class="count_card3" @click="click_kaipiao_record">
          <div>
            <span class="iconfont iconjilu icon_select"></span>

            <!-- <CountUp :end="interview_data.yaoyue.length" :duration="4" ref="count" v-font="22" /> -->
          </div>

          <div class="count_title ">结算历史记录</div>
        </div>
      </div>
    </div>
    <div class="title_text">
      <div>
        <Icon type="ios-bookmark" size="18" color="#0466dd" />
        <span class="title_text2">内部数据支持</span>
      </div>
    </div>
    <div class="data_div">
      <div class="card_main">
        <div class="card_main01">
          <div class="count_card3" @click="click_kaipiao_info">
            <div>
              <span class="iconfont iconkaipiaoxinxi icon_select"></span>
            </div>
            <div class="count_title ">开票与银行一览表</div>
          </div>
        </div>
      </div>
    </div>


    <Drawer title="保证金详情" :closable="true" v-model="cash_pledge_show" width="600">
      <div class="bzj_div">
        <Spin size="large" fix v-if="table_loading"></Spin>

        <div class="bzj_div2">
          <Button @click="add_cash_pledge" size="small" style="font-size: 12px" type="primary">
            <Icon type="md-add" />添加保证金
          </Button>
        </div>

        <Table size="small" :columns="cash_pledge_colunms" :data="cash_pledge_table" :height="windowHeight - 140">
        </Table>
      </div>

      <Modal v-model="add_cash_pledge_show" title="添加保证金" :mask-closable="false" :footer-hide="true" width="400">
        <div>
          <div class="">操作类型：</div>

          <Select v-model="add_cash_pledge_data.status" style="width: 300px">
            <Option value="0">支出</Option>

            <Option value="1">收回</Option>
          </Select>

          <div class="add_cash_pledge_title">操作日期：</div>

          <DatePicker v-model="add_cash_pledge_data.date" type="date" placeholder="Select date" style="width: 300px" />

          <div class="add_cash_pledge_title">金额：</div>

          <InputNumber :min="1" v-model="add_cash_pledge_data.money" style="width: 300px" />

          <div class="add_cash_pledge_title">备注：</div>

          <Input v-model="add_cash_pledge_data.remarks" placeholder="请输入备注..." style="width: 300px" />

          <div class="add_cash_div">
            <Button type="primary" @click="click_submit_data">确认</Button>
          </div>
        </div>
      </Modal>
    </Drawer>
  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {
  name: "kaipiao",
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      cash_pledge_balances: 0,
      start_invoice_money: 0,
      current_invioce_money: 0,
      current_returned_money: 0,
      weihuikuan_money: 0,

      loading: false,
      table_loading: false,

      cash_pledge_colunms: [],
      cash_pledge_table: [],
      cash_pledge_show: false,

      add_cash_pledge_show: false,
      add_cash_pledge_data: {
        status: "0",
        date: new Date(),
        money: 0,
        remarks: "",
      },

      current_month: new Date(),
    };
  },

  mounted() { },
  methods: {
    open(project_id) {
      this.project_id = project_id
      this.get_record_list();
    },

    click_submit_data() {
      if (this.add_cash_pledge_data.money == 0) {
        this.$Message.error("请填写金额");
        return;
      }
      if (this.add_cash_pledge_data.remarks == "") {
        this.$Message.error("请填写备注");
        return;
      }
      var that = this;
      var obj = {
        project_id: this.project_id,
        money: this.add_cash_pledge_data.money,
        date: this.add_cash_pledge_data.date.getTime() / 1000,
        remarks: this.add_cash_pledge_data.remarks,
        status: this.add_cash_pledge_data.status,
      };
      this.table_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/invoice/add_cash_pledge",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            console.log(res);
            that.cash_pledge_colunms = res.data.columns;
            that.cash_pledge_table = res.data.detail;
            that.add_cash_pledge_show = false;
            that.get_cash_pledge_list();
            that.get_record_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    add_cash_pledge() {
      this.add_cash_pledge_show = true;
    },

    click_cash_pledge() {
      this.cash_pledge_show = true;
      this.get_cash_pledge_list();
    },

    //获取保证金详情
    get_cash_pledge_list() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      this.table_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/invoice/cash_pledge_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            console.log(res);
            that.cash_pledge_colunms = res.data.columns;

            that.cash_pledge_table = res.data.detail;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    date_change() {
      this.get_record_list();
    },

    //获取结算历史记录
    get_record_list() {
      console.log("开始获取结算数据");
      var that = this;
      var obj = {
        project_id: this.project_id,
        current_month: Number(this.current_month.getTime() / 1000),
      };
      this.loading = true;
      http("post", process.env.VUE_APP_HOST + "/finance/invoice/jiesuan_heji", obj, true)
        .then((res) => {
          if (res.code == 0) {
            this.cash_pledge_balances = res.data.cash_pledge_balances;
            this.start_invoice_money = res.data.start_invoice_money;
            this.current_invioce_money = res.data.current_invioce_money;
            this.current_returned_money = res.data.current_returned_money;
            this.weihuikuan_money = res.data.weihuikuan_money;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
        })
        .catch((res) => {
          that.loading = false;

          console.log(res, "请求出错");
        });
    },

    click_kaipiao_info() {
      open_new_page("/tools/public_kaipiao?project_id=" + this.project_id);

    },

    click_kaipiao() {

      open_new_page("/finance/kaipiao?project_id=" + this.project_id);
    },

    click_kaipiao_record() {

      open_new_page("/finance/kaipiao_detail?project_id=" + this.project_id);
    },
  },
};
</script>

<style scoped>
.iconkaipiaoxinxi {
  font-size: 24px;
}

.add_cash_div {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}

.add_cash_pledge_title {
  margin-top: 10px;
}

.bzj_div2 {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

.bzj_div {
  position: relative;
}

.count_up {
  padding-top: 5px;
  height: 33px;
}

.count_card_div {
  display: flex;
  padding: 0 10px;
}

.iconjiesuan {
  font-size: 22px;
  color: #0466dd;
}

.iconjilu {
  font-size: 22px;
}

.icon_select {
  color: #0466dd;

}

.title_text2 {
  font-weight: 600;
}

.export_table {
  font-size: 12px;
  color: #0466dd;
  font-weight: 300;
  margin-right: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  letter-spacing: 1px;
}

.title_text {
  margin: 0px 10px 0 10px;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #ddd;
  padding: 10px 10px 5px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 2px;
}

.card_main {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  margin-right: 10px;
}

.card_main01 {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  margin-right: 10px;
}

.count_title2 {
  font-size: 13px;
  margin-top: 5px;
}

.count_title {
  font-size: 13px;
  margin-top: 5px;
}

.count_title10 {
  font-size: 13px;
  color: #fff;
  margin-top: 5px;
}

.count_card {
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 150px;
  border-radius: 5px;
  border: 1px solid #ececec;
  background-color: #fff;
  text-align: center;
}

.count_card3 {
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 150px;
  border-radius: 5px;
  border: 1px solid #b8bef7;
  background-color: #fff;
  text-align: center;
}

.count_card3:hover {
  border: 1px solid #0466dd;
  background: #0466dd;
  color: #fff;


}

.count_card3:hover .icon_select {
  color: #fff;
}

.count_card10 {
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 150px;
  border-radius: 5px;
  background-color: #9add9d;
  text-align: center;
}

.count_card10:hover {
  box-shadow: 0 0 3px #919ea6;
}

.data_div {
  padding: 10px;
  border-radius: 5px;
}

.query_box {
  display: flex;
  justify-content: flex-end;
}
</style>
